import { convertToRaw } from 'draft-js';
import { BLOCK_TYPE } from './CONSTANTS';

export default (editorState) => {
    if (!editorState) {
        return {};
    }
    const content = editorState.getCurrentContent();
    const rawContent = convertToRaw(content);

    content.getBlocksAsArray().forEach((block, index) => {
        if (block.getType().toLowerCase() !== BLOCK_TYPE.ATOMIC && Array.isArray(block.getIn(['data', 'rows']))) {
            rawContent.blocks[index].data.rows = [];
        } else if (block.getType().toLowerCase() === BLOCK_TYPE.ATOMIC && Array.isArray(block.getIn(['data', 'rows']))) {
            rawContent.blocks[index].data.rows = block.getIn(['data', 'rows']).map(row => row.map(cell => convertToRaw(cell.getCurrentContent())));
        }
    });

    return rawContent;
};
